module.exports = __webpack_public_path__ + "img/image_charactor.2bb3971a.png";